import { render } from "./Info1.vue?vue&type=template&id=938c547c&scoped=true"
import script from "./Info1.vue?vue&type=script&lang=js"
export * from "./Info1.vue?vue&type=script&lang=js"

import "./Info1.vue?vue&type=style&index=0&id=938c547c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938c547c"]])

export default __exports__